import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ed375ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2ed375ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed375ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed375ca')) {
      api.createRecord('2ed375ca', component.options)
    } else {
      api.reload('2ed375ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ed375ca&scoped=true", function () {
      api.rerender('2ed375ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P2_Page/SevenKeepSignin/index.vue"
export default component.exports